// extracted by mini-css-extract-plugin
export default {"panel":"lsf-panel","panel_alignment_left":"lsf-panel_alignment_left","panel_alignment_right":"lsf-panel_alignment_right","panel_detached":"lsf-panel_detached","panel_hidden":"lsf-panel_hidden","panel__header":"lsf-panel__header","panel__content":"lsf-panel__content","panel_resizing":"lsf-panel_resizing","panel__body":"lsf-panel__body","panel__resizer":"lsf-panel__resizer","panel__resizer_drag":"lsf-panel__resizer_drag","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630378579
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  